import { TableBody, TableRow, TableCell } from '@mui/material'
import PageList from './PageList'

const HierarchicalTableContent = ({ sitemap, prevSitemap, checkedPages, setCheckedPages, handleOpenDeleteDialog }) => {
  return (
    <TableBody>
      <TableRow className='pagesHierarchicalTableBodyRow'>
        <TableCell colSpan={6} className='pagesHierarchicalTableCommonCell'>
          <PageList
            sitemap={sitemap}
            prevSitemap={prevSitemap}
            checkedPages={checkedPages}
            setCheckedPages={setCheckedPages}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
          />
        </TableCell>
      </TableRow>
    </TableBody>
  )
}

export default HierarchicalTableContent